import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import { NoColorSpace, DoubleSide } from 'three';
import { strToU8, zipSync } from '../libs/fflate.module.js';
import { decompress } from './../utils/TextureUtils.js';
var USDZExporter = /*#__PURE__*/function () {
  function USDZExporter() {
    _classCallCheck(this, USDZExporter);
  }
  _createClass(USDZExporter, [{
    key: "parse",
    value: function parse(scene, onDone, onError, options) {
      this.parseAsync(scene, options).then(onDone).catch(onError);
    }
  }, {
    key: "parseAsync",
    value: function () {
      var _parseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(scene) {
        var options,
          files,
          modelFileName,
          output,
          materials,
          textures,
          _loop,
          id,
          offset,
          filename,
          file,
          headerSize,
          offsetMod64,
          padLength,
          padding,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              options = Object.assign({
                ar: {
                  anchoring: {
                    type: 'plane'
                  },
                  planeAnchoring: {
                    alignment: 'horizontal'
                  }
                },
                includeAnchoringProperties: true,
                quickLookCompatible: false,
                maxTextureSize: 1024
              }, options);
              files = {};
              modelFileName = 'model.usda'; // model file should be first in USDZ archive so we init it here
              files[modelFileName] = null;
              output = buildHeader();
              output += buildSceneStart(options);
              materials = {};
              textures = {};
              scene.traverseVisible(function (object) {
                if (object.isMesh) {
                  var geometry = object.geometry;
                  var material = object.material;
                  if (material.isMeshStandardMaterial) {
                    var geometryFileName = 'geometries/Geometry_' + geometry.id + '.usda';
                    if (!(geometryFileName in files)) {
                      var meshObject = buildMeshObject(geometry);
                      files[geometryFileName] = buildUSDFileAsString(meshObject);
                    }
                    if (!(material.uuid in materials)) {
                      materials[material.uuid] = material;
                    }
                    output += buildXform(object, geometry, material);
                  } else {
                    console.warn('THREE.USDZExporter: Unsupported material type (USDZ only supports MeshStandardMaterial)', object);
                  }
                } else if (object.isCamera) {
                  output += buildCamera(object);
                }
              });
              output += buildSceneEnd();
              output += buildMaterials(materials, textures, options.quickLookCompatible);
              files[modelFileName] = strToU8(output);
              output = null;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var texture, canvas, blob;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      texture = textures[id];
                      if (texture.isCompressedTexture === true) {
                        texture = decompress(texture);
                      }
                      canvas = imageToCanvas(texture.image, texture.flipY, options.maxTextureSize);
                      _context.next = 5;
                      return new Promise(function (resolve) {
                        return canvas.toBlob(resolve, 'image/png', 1);
                      });
                    case 5:
                      blob = _context.sent;
                      _context.t0 = Uint8Array;
                      _context.next = 9;
                      return blob.arrayBuffer();
                    case 9:
                      _context.t1 = _context.sent;
                      files["textures/Texture_".concat(id, ".png")] = new _context.t0(_context.t1);
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _context2.t0 = _regeneratorRuntime.keys(textures);
            case 16:
              if ((_context2.t1 = _context2.t0()).done) {
                _context2.next = 21;
                break;
              }
              id = _context2.t1.value;
              return _context2.delegateYield(_loop(), "t2", 19);
            case 19:
              _context2.next = 16;
              break;
            case 21:
              // 64 byte alignment
              // https://github.com/101arrowz/fflate/issues/39#issuecomment-777263109
              offset = 0;
              for (filename in files) {
                file = files[filename];
                headerSize = 34 + filename.length;
                offset += headerSize;
                offsetMod64 = offset & 63;
                if (offsetMod64 !== 4) {
                  padLength = 64 - offsetMod64;
                  padding = new Uint8Array(padLength);
                  files[filename] = [file, {
                    extra: {
                      12345: padding
                    }
                  }];
                }
                offset = file.length;
              }
              return _context2.abrupt("return", zipSync(files, {
                level: 0
              }));
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }));
      function parseAsync(_x) {
        return _parseAsync.apply(this, arguments);
      }
      return parseAsync;
    }()
  }]);
  return USDZExporter;
}();
function imageToCanvas(image, flipY, maxTextureSize) {
  if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof OffscreenCanvas !== 'undefined' && image instanceof OffscreenCanvas || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
    var scale = maxTextureSize / Math.max(image.width, image.height);
    var canvas = document.createElement('canvas');
    canvas.width = image.width * Math.min(1, scale);
    canvas.height = image.height * Math.min(1, scale);
    var context = canvas.getContext('2d');

    // TODO: We should be able to do this in the UsdTransform2d?

    if (flipY === true) {
      context.translate(0, canvas.height);
      context.scale(1, -1);
    }
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas;
  } else {
    throw new Error('THREE.USDZExporter: No valid image data found. Unable to process texture.');
  }
}

//

var PRECISION = 7;
function buildHeader() {
  return "#usda 1.0\n(\n\tcustomLayerData = {\n\t\tstring creator = \"Three.js USDZExporter\"\n\t}\n\tdefaultPrim = \"Root\"\n\tmetersPerUnit = 1\n\tupAxis = \"Y\"\n)\n\n";
}
function buildSceneStart(options) {
  var alignment = options.includeAnchoringProperties === true ? "\n\t\ttoken preliminary:anchoring:type = \"".concat(options.ar.anchoring.type, "\"\n\t\ttoken preliminary:planeAnchoring:alignment = \"").concat(options.ar.planeAnchoring.alignment, "\"\n\t") : '';
  return "def Xform \"Root\"\n{\n\tdef Scope \"Scenes\" (\n\t\tkind = \"sceneLibrary\"\n\t)\n\t{\n\t\tdef Xform \"Scene\" (\n\t\t\tcustomData = {\n\t\t\t\tbool preliminary_collidesWithEnvironment = 0\n\t\t\t\tstring sceneName = \"Scene\"\n\t\t\t}\n\t\t\tsceneName = \"Scene\"\n\t\t)\n\t\t{".concat(alignment, "\n");
}
function buildSceneEnd() {
  return "\n\t\t}\n\t}\n}\n\n";
}
function buildUSDFileAsString(dataToInsert) {
  var output = buildHeader();
  output += dataToInsert;
  return strToU8(output);
}

// Xform

function buildXform(object, geometry, material) {
  var name = 'Object_' + object.id;
  var transform = buildMatrix(object.matrixWorld);
  if (object.matrixWorld.determinant() < 0) {
    console.warn('THREE.USDZExporter: USDZ does not support negative scales', object);
  }
  return "def Xform \"".concat(name, "\" (\n\tprepend references = @./geometries/Geometry_").concat(geometry.id, ".usda@</Geometry>\n\tprepend apiSchemas = [\"MaterialBindingAPI\"]\n)\n{\n\tmatrix4d xformOp:transform = ").concat(transform, "\n\tuniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n\trel material:binding = </Materials/Material_").concat(material.id, ">\n}\n\n");
}
function buildMatrix(matrix) {
  var array = matrix.elements;
  return "( ".concat(buildMatrixRow(array, 0), ", ").concat(buildMatrixRow(array, 4), ", ").concat(buildMatrixRow(array, 8), ", ").concat(buildMatrixRow(array, 12), " )");
}
function buildMatrixRow(array, offset) {
  return "(".concat(array[offset + 0], ", ").concat(array[offset + 1], ", ").concat(array[offset + 2], ", ").concat(array[offset + 3], ")");
}

// Mesh

function buildMeshObject(geometry) {
  var mesh = buildMesh(geometry);
  return "\ndef \"Geometry\"\n{\n".concat(mesh, "\n}\n");
}
function buildMesh(geometry) {
  var name = 'Geometry';
  var attributes = geometry.attributes;
  var count = attributes.position.count;
  return "\n\tdef Mesh \"".concat(name, "\"\n\t{\n\t\tint[] faceVertexCounts = [").concat(buildMeshVertexCount(geometry), "]\n\t\tint[] faceVertexIndices = [").concat(buildMeshVertexIndices(geometry), "]\n\t\tnormal3f[] normals = [").concat(buildVector3Array(attributes.normal, count), "] (\n\t\t\tinterpolation = \"vertex\"\n\t\t)\n\t\tpoint3f[] points = [").concat(buildVector3Array(attributes.position, count), "]\n").concat(buildPrimvars(attributes), "\n\t\tuniform token subdivisionScheme = \"none\"\n\t}\n");
}
function buildMeshVertexCount(geometry) {
  var count = geometry.index !== null ? geometry.index.count : geometry.attributes.position.count;
  return Array(count / 3).fill(3).join(', ');
}
function buildMeshVertexIndices(geometry) {
  var index = geometry.index;
  var array = [];
  if (index !== null) {
    for (var i = 0; i < index.count; i++) {
      array.push(index.getX(i));
    }
  } else {
    var length = geometry.attributes.position.count;
    for (var _i = 0; _i < length; _i++) {
      array.push(_i);
    }
  }
  return array.join(', ');
}
function buildVector3Array(attribute, count) {
  if (attribute === undefined) {
    console.warn('USDZExporter: Normals missing.');
    return Array(count).fill('(0, 0, 0)').join(', ');
  }
  var array = [];
  for (var i = 0; i < attribute.count; i++) {
    var x = attribute.getX(i);
    var y = attribute.getY(i);
    var z = attribute.getZ(i);
    array.push("(".concat(x.toPrecision(PRECISION), ", ").concat(y.toPrecision(PRECISION), ", ").concat(z.toPrecision(PRECISION), ")"));
  }
  return array.join(', ');
}
function buildVector2Array(attribute) {
  var array = [];
  for (var i = 0; i < attribute.count; i++) {
    var x = attribute.getX(i);
    var y = attribute.getY(i);
    array.push("(".concat(x.toPrecision(PRECISION), ", ").concat(1 - y.toPrecision(PRECISION), ")"));
  }
  return array.join(', ');
}
function buildPrimvars(attributes) {
  var string = '';
  for (var i = 0; i < 4; i++) {
    var id = i > 0 ? i : '';
    var attribute = attributes['uv' + id];
    if (attribute !== undefined) {
      string += "\n\t\ttexCoord2f[] primvars:st".concat(id, " = [").concat(buildVector2Array(attribute), "] (\n\t\t\tinterpolation = \"vertex\"\n\t\t)");
    }
  }

  // vertex colors

  var colorAttribute = attributes.color;
  if (colorAttribute !== undefined) {
    var count = colorAttribute.count;
    string += "\n\tcolor3f[] primvars:displayColor = [".concat(buildVector3Array(colorAttribute, count), "] (\n\t\tinterpolation = \"vertex\"\n\t\t)");
  }
  return string;
}

// Materials

function buildMaterials(materials, textures) {
  var quickLookCompatible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var array = [];
  for (var uuid in materials) {
    var material = materials[uuid];
    array.push(buildMaterial(material, textures, quickLookCompatible));
  }
  return "def \"Materials\"\n{\n".concat(array.join(''), "\n}\n\n");
}
function buildMaterial(material, textures) {
  var quickLookCompatible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // https://graphics.pixar.com/usd/docs/UsdPreviewSurface-Proposal.html

  var pad = '			';
  var inputs = [];
  var samplers = [];
  function buildTexture(texture, mapType, color) {
    var id = texture.source.id + '_' + texture.flipY;
    textures[id] = texture;
    var uv = texture.channel > 0 ? 'st' + texture.channel : 'st';
    var WRAPPINGS = {
      1000: 'repeat',
      // RepeatWrapping
      1001: 'clamp',
      // ClampToEdgeWrapping
      1002: 'mirror' // MirroredRepeatWrapping
    };

    var repeat = texture.repeat.clone();
    var offset = texture.offset.clone();
    var rotation = texture.rotation;

    // rotation is around the wrong point. after rotation we need to shift offset again so that we're rotating around the right spot
    var xRotationOffset = Math.sin(rotation);
    var yRotationOffset = Math.cos(rotation);

    // texture coordinates start in the opposite corner, need to correct
    offset.y = 1 - offset.y - repeat.y;

    // turns out QuickLook is buggy and interprets texture repeat inverted/applies operations in a different order.
    // Apple Feedback: 	FB10036297 and FB11442287
    if (quickLookCompatible) {
      // This is NOT correct yet in QuickLook, but comes close for a range of models.
      // It becomes more incorrect the bigger the offset is

      offset.x = offset.x / repeat.x;
      offset.y = offset.y / repeat.y;
      offset.x += xRotationOffset / repeat.x;
      offset.y += yRotationOffset - 1;
    } else {
      // results match glTF results exactly. verified correct in usdview.
      offset.x += xRotationOffset * repeat.x;
      offset.y += (1 - yRotationOffset) * repeat.y;
    }
    return "\n\t\tdef Shader \"PrimvarReader_".concat(mapType, "\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdPrimvarReader_float2\"\n\t\t\tfloat2 inputs:fallback = (0.0, 0.0)\n\t\t\ttoken inputs:varname = \"").concat(uv, "\"\n\t\t\tfloat2 outputs:result\n\t\t}\n\n\t\tdef Shader \"Transform2d_").concat(mapType, "\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdTransform2d\"\n\t\t\ttoken inputs:in.connect = </Materials/Material_").concat(material.id, "/PrimvarReader_").concat(mapType, ".outputs:result>\n\t\t\tfloat inputs:rotation = ").concat((rotation * (180 / Math.PI)).toFixed(PRECISION), "\n\t\t\tfloat2 inputs:scale = ").concat(buildVector2(repeat), "\n\t\t\tfloat2 inputs:translation = ").concat(buildVector2(offset), "\n\t\t\tfloat2 outputs:result\n\t\t}\n\n\t\tdef Shader \"Texture_").concat(texture.id, "_").concat(mapType, "\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdUVTexture\"\n\t\t\tasset inputs:file = @textures/Texture_").concat(id, ".png@\n\t\t\tfloat2 inputs:st.connect = </Materials/Material_").concat(material.id, "/Transform2d_").concat(mapType, ".outputs:result>\n\t\t\t").concat(color !== undefined ? 'float4 inputs:scale = ' + buildColor4(color) : '', "\n\t\t\ttoken inputs:sourceColorSpace = \"").concat(texture.colorSpace === NoColorSpace ? 'raw' : 'sRGB', "\"\n\t\t\ttoken inputs:wrapS = \"").concat(WRAPPINGS[texture.wrapS], "\"\n\t\t\ttoken inputs:wrapT = \"").concat(WRAPPINGS[texture.wrapT], "\"\n\t\t\tfloat outputs:r\n\t\t\tfloat outputs:g\n\t\t\tfloat outputs:b\n\t\t\tfloat3 outputs:rgb\n\t\t\t").concat(material.transparent || material.alphaTest > 0.0 ? 'float outputs:a' : '', "\n\t\t}");
  }
  if (material.side === DoubleSide) {
    console.warn('THREE.USDZExporter: USDZ does not support double sided materials', material);
  }
  if (material.map !== null) {
    inputs.push("".concat(pad, "color3f inputs:diffuseColor.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.map.id, "_diffuse.outputs:rgb>"));
    if (material.transparent) {
      inputs.push("".concat(pad, "float inputs:opacity.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.map.id, "_diffuse.outputs:a>"));
    } else if (material.alphaTest > 0.0) {
      inputs.push("".concat(pad, "float inputs:opacity.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.map.id, "_diffuse.outputs:a>"));
      inputs.push("".concat(pad, "float inputs:opacityThreshold = ").concat(material.alphaTest));
    }
    samplers.push(buildTexture(material.map, 'diffuse', material.color));
  } else {
    inputs.push("".concat(pad, "color3f inputs:diffuseColor = ").concat(buildColor(material.color)));
  }
  if (material.emissiveMap !== null) {
    inputs.push("".concat(pad, "color3f inputs:emissiveColor.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.emissiveMap.id, "_emissive.outputs:rgb>"));
    samplers.push(buildTexture(material.emissiveMap, 'emissive'));
  } else if (material.emissive.getHex() > 0) {
    inputs.push("".concat(pad, "color3f inputs:emissiveColor = ").concat(buildColor(material.emissive)));
  }
  if (material.normalMap !== null) {
    inputs.push("".concat(pad, "normal3f inputs:normal.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.normalMap.id, "_normal.outputs:rgb>"));
    samplers.push(buildTexture(material.normalMap, 'normal'));
  }
  if (material.aoMap !== null) {
    inputs.push("".concat(pad, "float inputs:occlusion.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.aoMap.id, "_occlusion.outputs:r>"));
    samplers.push(buildTexture(material.aoMap, 'occlusion'));
  }
  if (material.roughnessMap !== null && material.roughness === 1) {
    inputs.push("".concat(pad, "float inputs:roughness.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.roughnessMap.id, "_roughness.outputs:g>"));
    samplers.push(buildTexture(material.roughnessMap, 'roughness'));
  } else {
    inputs.push("".concat(pad, "float inputs:roughness = ").concat(material.roughness));
  }
  if (material.metalnessMap !== null && material.metalness === 1) {
    inputs.push("".concat(pad, "float inputs:metallic.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.metalnessMap.id, "_metallic.outputs:b>"));
    samplers.push(buildTexture(material.metalnessMap, 'metallic'));
  } else {
    inputs.push("".concat(pad, "float inputs:metallic = ").concat(material.metalness));
  }
  if (material.alphaMap !== null) {
    inputs.push("".concat(pad, "float inputs:opacity.connect = </Materials/Material_").concat(material.id, "/Texture_").concat(material.alphaMap.id, "_opacity.outputs:r>"));
    inputs.push("".concat(pad, "float inputs:opacityThreshold = 0.0001"));
    samplers.push(buildTexture(material.alphaMap, 'opacity'));
  } else {
    inputs.push("".concat(pad, "float inputs:opacity = ").concat(material.opacity));
  }
  if (material.isMeshPhysicalMaterial) {
    inputs.push("".concat(pad, "float inputs:clearcoat = ").concat(material.clearcoat));
    inputs.push("".concat(pad, "float inputs:clearcoatRoughness = ").concat(material.clearcoatRoughness));
    inputs.push("".concat(pad, "float inputs:ior = ").concat(material.ior));
  }
  return "\n\tdef Material \"Material_".concat(material.id, "\"\n\t{\n\t\tdef Shader \"PreviewSurface\"\n\t\t{\n\t\t\tuniform token info:id = \"UsdPreviewSurface\"\n").concat(inputs.join('\n'), "\n\t\t\tint inputs:useSpecularWorkflow = 0\n\t\t\ttoken outputs:surface\n\t\t}\n\n\t\ttoken outputs:surface.connect = </Materials/Material_").concat(material.id, "/PreviewSurface.outputs:surface>\n\n").concat(samplers.join('\n'), "\n\n\t}\n");
}
function buildColor(color) {
  return "(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ")");
}
function buildColor4(color) {
  return "(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", 1.0)");
}
function buildVector2(vector) {
  return "(".concat(vector.x, ", ").concat(vector.y, ")");
}
function buildCamera(camera) {
  var name = camera.name ? camera.name : 'Camera_' + camera.id;
  var transform = buildMatrix(camera.matrixWorld);
  if (camera.matrixWorld.determinant() < 0) {
    console.warn('THREE.USDZExporter: USDZ does not support negative scales', camera);
  }
  if (camera.isOrthographicCamera) {
    return "def Camera \"".concat(name, "\"\n\t\t{\n\t\t\tmatrix4d xformOp:transform = ").concat(transform, "\n\t\t\tuniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n\t\t\tfloat2 clippingRange = (").concat(camera.near.toPrecision(PRECISION), ", ").concat(camera.far.toPrecision(PRECISION), ")\n\t\t\tfloat horizontalAperture = ").concat(((Math.abs(camera.left) + Math.abs(camera.right)) * 10).toPrecision(PRECISION), "\n\t\t\tfloat verticalAperture = ").concat(((Math.abs(camera.top) + Math.abs(camera.bottom)) * 10).toPrecision(PRECISION), "\n\t\t\ttoken projection = \"orthographic\"\n\t\t}\n\t\n\t");
  } else {
    return "def Camera \"".concat(name, "\"\n\t\t{\n\t\t\tmatrix4d xformOp:transform = ").concat(transform, "\n\t\t\tuniform token[] xformOpOrder = [\"xformOp:transform\"]\n\n\t\t\tfloat2 clippingRange = (").concat(camera.near.toPrecision(PRECISION), ", ").concat(camera.far.toPrecision(PRECISION), ")\n\t\t\tfloat focalLength = ").concat(camera.getFocalLength().toPrecision(PRECISION), "\n\t\t\tfloat focusDistance = ").concat(camera.focus.toPrecision(PRECISION), "\n\t\t\tfloat horizontalAperture = ").concat(camera.getFilmWidth().toPrecision(PRECISION), "\n\t\t\ttoken projection = \"perspective\"\n\t\t\tfloat verticalAperture = ").concat(camera.getFilmHeight().toPrecision(PRECISION), "\n\t\t}\n\t\n\t");
  }
}
export { USDZExporter };